export default __webpack_public_path__ + "static/works-2-1-6bb2207573a717f82ff15e973fbd4ad6.jpg";